var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('AdminSidebar'),_c('div',{staticClass:"height-100 lighten-4 px-12 py-6"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }